import React from "react";
import MealBoxesSelection from "./MealBoxesSelection";
import {SubscriptionInfoProvider} from "./useCustomerSubscriptionInfo";
import {createBrowserRouter, createRoutesFromElements, Route, RouterProvider} from "react-router-dom";
import AddonsSelection from "./AddonsSelection";

const CheckoutManagementV2 = (): React.ReactElement =>
  <SubscriptionInfoProvider>
    <RouterProvider router={router} />
  </SubscriptionInfoProvider>;

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/">
      <Route path=":language?/collections">
        <Route path="boxes" element={<MealBoxesSelection />} />
        <Route path="lisakastid" element={<AddonsSelection />} />
      </Route>
    </Route>,
  ),
);

export default CheckoutManagementV2;
